export default "__VITE_ASSET__D6VQQ9Gq__"